import { API_URL } from "constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (eventId) => `${API_URL}/api/v1/crm/appointment/current?id=${eventId}`;

export const getAppointement = async (eventId) => {
    const url = getUrl(eventId);
    return await apiRequest(url, "get");
};
